<div class="investor-cell d-flex align-items-center s-gap-c-3">
  <div
    class="avatar rounded-circle d-flex align-items-center justify-content-center c-white"
    [style.background-color]="row().avatarColor"
  >
    {{ row().initials }}
  </div>
  <div class="d-flex flex-column align-items-start">
    <strong>{{ row().name }}</strong>
    <span class="cpf s-small c-platform-mid">{{ row().cpf }}</span>
  </div>
</div>
